import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import Confirmation from 'components/form/confirmation';
import PlanMutation from 'mutations/plan/select';

const ChangePlanButton = ({ plan, disabled, active }) => {
  const setError = useError();

  const [planMutation, { loading }] = useMutation(PlanMutation, {
    onCompleted: (data) => {
      if (data.selectPlan.paymentUrl) {
        window.location.href = data.selectPlan.paymentUrl;
      } else {
        setError('error.plan.select');
      }
    },
    onError: () => {
      setError('error.plan.select');
    },
  });

  return (
    <Confirmation
      disabled={loading || disabled}
      title={<FormattedMessage id="header.user.plan.change" />}
      description={<FormattedMessage id="confirmation.user.plan.change" />}
      onClick={() => {
        planMutation({ variables: { id: plan.id } });
      }}
    >
      <Button variant="outlined" disabled={loading || disabled}>
        {active ? (
          <FormattedMessage id="button.plan.renew" />
        ) : (
          <FormattedMessage id="button.plan.change" />
        )}
      </Button>
    </Confirmation>
  );
};

export default ChangePlanButton;
